export default "/25f710847dd0be805cb8ee54d4e27cd8317d2a0f/a70fe28c30edbe909cade8425716fdee.svg";